module.exports = __webpack_public_path__ + "static/media/rose.bfd6b966.jpeg";